import { IGetPriceBandsResponseData } from 'src/api/getPriceBands';
import { IPriceBandWithVenues, IPriceBandVenue } from 'src/types/priceBand.types';

export const formatPriceBands = (priceBands: IGetPriceBandsResponseData[]): IPriceBandWithVenues[] =>
  priceBands.map(
    ({ price_band_id, name, venues }: IGetPriceBandsResponseData): IPriceBandWithVenues => ({
      priceBandId: price_band_id,
      name,
      venues: venues.map(
        ({ name, venue_id }): IPriceBandVenue => ({
          name,
          venueId: venue_id,
        }),
      ),
    }),
  );
